import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/hashtag/importer/hashtagImporterActions'

export default importerReducers(actions)
